import React from "react";
import "./NotificationRuleTable.css";
import { Table, Popconfirm, Switch } from "antd";
import { useSelector } from "react-redux";
import lang from "../../../../services/lang";

function NotificationRuleTable(props) {
  const { langIndex } = useSelector((x) => x.app);
  const { ruleList, deleteRule, onClickEditRecord, selCustomerId } = props;

  const getTriggerTypeLabel = (triggerType) => {
    switch (triggerType) {
      case "cycle_stop_alert":
        return lang(langIndex, "notification_trigger_cycle_stop_alert");
      case "machine_status":
        return lang(langIndex, "notification_trigger_machine_status");
      case "maintenance_task":
        return lang(langIndex, "notification_trigger_maintenance_task");
      case "iot_sensor":
        return lang(langIndex, "notification_trigger_iot_sensor");
      default:
        return triggerType;
    }
  };

  const getNotificationMethodsLabel = (methods) => {
    if (!methods || !Array.isArray(methods)) return "-";
    return methods.map((method) => {
      switch (method) {
        case "email":
          return lang(langIndex, "notification_method_email");
        case "sms":
          return lang(langIndex, "notification_method_sms");
        case "app":
          return lang(langIndex, "notification_method_app");
        default:
          return method;
      }
    }).join(", ");
  };

  const getTimingLabel = (timingType, delayMinutes) => {
    if (timingType === "immediate") {
      return lang(langIndex, "notification_timing_immediate");
    } else {
      return lang(langIndex, "notification_timing_delayed") + ` (${delayMinutes} ${lang(langIndex, "notification_minutes")})`;
    }
  };

  const getRepeatLabel = (repeatType, intervalMinutes) => {
    if (repeatType === "one_time") {
      return lang(langIndex, "notification_repeat_one_time");
    } else {
      return lang(langIndex, "notification_repeat_repeat") + ` (${intervalMinutes} ${lang(langIndex, "notification_minutes")})`;
    }
  };

  const columns = [
    {
      title: lang(langIndex, "notification_rule_name"),
      dataIndex: "rule_name",
      key: "rule_name",
      width: 200,
    },
    {
      title: lang(langIndex, "notification_trigger_type"),
      dataIndex: "trigger_type",
      key: "trigger_type",
      width: 200,
      render: (trigger_type) => {
        return getTriggerTypeLabel(trigger_type);
      },
    },
    {
      title: lang(langIndex, "notification_methods"),
      dataIndex: "notification_methods",
      key: "notification_methods",
      width: 150,
      render: (methods) => {
        return getNotificationMethodsLabel(methods);
      },
    },
    {
      title: lang(langIndex, "notification_timing"),
      dataIndex: "timing_type",
      key: "timing_type",
      width: 150,
      render: (timing_type, record) => {
        return getTimingLabel(timing_type, record.delay_minutes);
      },
    },
    {
      title: lang(langIndex, "notification_repeat"),
      dataIndex: "repeat_type",
      key: "repeat_type",
      width: 150,
      render: (repeat_type, record) => {
        return getRepeatLabel(repeat_type, record.repeat_interval_minutes);
      },
    },
    {
      title: lang(langIndex, "notification_active"),
      dataIndex: "is_active",
      key: "is_active",
      width: 100,
      render: (is_active) => {
        const active = is_active === 1 || is_active === "1" || is_active === true;
        return active ? lang(langIndex, "plant_yes") : lang(langIndex, "plant_no");
      },
    },
    {
      title: lang(langIndex, "jobentry_operation"),
      dataIndex: "operation",
      width: 150,
      render: (_, record) => {
        return (
          <div>
            <a onClick={() => editRecord(record)}>
              {lang(langIndex, "jobentry_edit")}
            </a>
            <Popconfirm
              title={lang(langIndex, "jobentry_suretodelete")}
              onConfirm={() => deleteRecord(record)}
            >
              <a style={{ marginLeft: 10, color: "red" }}>
                {lang(langIndex, "jobentry_delete")}
              </a>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const editRecord = (record) => {
    onClickEditRecord(record);
  };

  const deleteRecord = (record) => {
    deleteRule(record.id);
  };

  return (
    <div>
      <Table
        className="user-table-style"
        dataSource={ruleList}
        columns={columns}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1000 }}
      />
    </div>
  );
}

export default NotificationRuleTable;

